var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEssay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9651667,9.43720833 C30.3189167,8.76941667 30.3541667,7.71975 31.02,7.0735 L37.8134583,0.483708333 C38.146375,0.162541667 38.5713333,0 38.9943333,0 C39.4232083,0 39.8520833,0.166458333 40.1771667,0.503291667 L30.9651667,9.43720833 L30.9651667,9.43720833 Z M19.792875,26.2240417 C19.6557917,26.3591667 19.5833333,26.5412917 19.5833333,26.7234167 C19.5833333,27.1033333 19.89275,27.4166667 20.2765833,27.4166667 C20.450875,27.4166667 20.6251667,27.3520417 20.7602917,27.2208333 L21.902,26.1104583 L20.9365417,25.1136667 L19.792875,26.2240417 Z M29.4357083,13.3930417 L25.5307917,17.1785 C23.4314583,19.2132083 22.36025,21.18525 21.3712917,23.9367083 L23.0965833,25.7168333 C25.8754583,24.8140417 27.8788333,23.8055 29.9781667,21.7688333 L33.8830833,17.9814167 L29.4357083,13.3930417 L29.4357083,13.3930417 Z M40.825375,1.72529167 L30.7654167,11.4817083 L35.8296667,16.7124167 L45.8915833,6.95991667 C46.629875,6.24316667 47,5.293375 47,4.341625 C47,1.16129167 43.146,-0.526791667 40.825375,1.72529167 Z M17.625,25.4583333 L9.79166667,25.4583333 L9.79166667,27.4166667 L17.625,27.4166667 L17.625,25.4583333 Z M35.25,22.8145833 L35.25,26.5217083 C35.25,34.5645833 23.5,31.3333333 23.5,31.3333333 C23.5,31.3333333 26.47275,43.0833333 18.3339167,43.0833333 L3.91666667,43.0833333 L3.91666667,3.91666667 L28.6484583,3.91666667 L32.6865417,0 L0,0 L0,47 L19.9534583,47 C26.1476667,47 39.1666667,32.8549583 39.1666667,28.1725833 L39.1666667,18.993875 L35.25,22.8145833 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssay);
export default __webpack_public_path__ + "static/media/Essay.f14ad96d.svg";
export { ForwardRef as ReactComponent };